import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';
import paymentSuccess from '@/assets/lotties/payment_success.json';
import paymentLoading from '@/assets/lotties/pending_validation.json';

export const EVENTS = {
  SERVICES: {
    START: 'services.start',
    OPTIONS: {
      SELECT: 'services.options.select',
      SELECTED: 'services.options.selected'
    },
    INITIATION: {
      SUBMIT_FORM: 'services.initiation.submit_form',
      CONFIRM: 'services.initiation.CONFIRM',
      INITIATION_FAILED: 'services.initiation.INITIATION_FAILED',
      INITIATED: 'services.initiation.INITIATED',
      REQUEST_MANUAL_PAYMENT: 'services.initiation.REQUEST_MANUAL_PAYMENT',
      REQUEST_MANUAL_LAUNCH: 'services.initiation.REQUEST_MANUAL_LAUNCH',
      MANUAL_INFO_SUBMITTED: 'services.initiation.MANUAL_INFO_SUBMITTED',
      MANUAL_LAUNCH_DONE: 'services.initiation.MANUAL_LAUNCH_DONE',
      REQUEST_OTP: 'services.initiation.REQUEST_OTP',
      OTP_SUBMITTED: 'services.initiation.OTP_SUBMITTED',
      WAVE_PAYMENT_LINK_POLLING_START: 'services.initiation.WAVE_PAYMENT_LINK_POLLING_START',
      WAVE_PAYMENT_LINK_FOUND: 'services.initiation.WAVE_PAYMENT_LINK_FOUND',
      WAVE_PAYMENT_LINK_TIMEOUT: 'services.initiation.WAVE_PAYMENT_LINK_TIMEOUT'
    },
    PHONE_UPDATE: {
      START: 'services.phone_update.start',
      SUBMIT_NEW_NUMBER: 'services.phone_update.submit_new_number',
      PAYMENT_SUCCESS: 'services.phone_update.payment_success',
      PAYMENT_FAILED: 'services.phone_update.payment_failed',
      COMPLETED: 'services.phone_update.completed'
    },
    CLOSE_OPERATION_INITIATION: 'services.close_operation_initiation',
    CLOSE_SERVICE_INITIATION: 'services.CLOSE_SERVICE_INITIATION'
  }
};

export const ENDPOINTS = {
  SERVICES: {
    CALCULATE_FEES:
      'https://api.kingrecharges.com/fees/applyFee?amount={amount}&group=payment&computeAmountToPay={computeAmountToPay}',
    INITIATE:
      'https://api.kingrecharges.com/queue/broadcast/data/lacasae-group-transaction/operationCreated?group=commons',
    ADD_TOKEN:
      'https://api.kingrecharges.com/queue/broadcast/data/lacasae-group-transaction/addToken?group=commons',
    INITIATE_PHONE_VERIFICATION:
      'https://api.kingrecharges.com/queue/broadcast/data/lacasae-group-transaction/phoneVerificationCreated?group=commons',
    CHECK_PHONE_VERIFICATION_STATUS:
      'https://api.kingrecharges.com/queue/broadcast/data/lacasae-group-transaction/checkPhoneVerificationStatus?id={id}',
    GET_TRANSACTION_DETAIL:
      '/onebpay-transactions/{id}?limit=300&group=lacasae',
    CHECK_BLACKLIST:
      'https://api.kingrecharges.com/bookmaker/check/{id}?group=lacasae&service=1bpay&currency={currency}'
  }
};

export const SERVICES = {
  LOTTIES: {
    EMPTY_TRANSACTION: emptyTransactions,
    LOADING_ERROR: loadingError,
    PAYMENT_ERROR: loadingError,
    PAYMENT_LOADING: paymentLoading,
    PAYMENT_SUCCESS: paymentSuccess
  },
  SERVICES_CATEGORIES: [
    { id: 'crypto', name: 'Crypto' },
    { id: 'recharges', name: 'Recharges & retraits' },
    { id: 'others', name: 'Divers' }
  ],
  // Liste complète des services (inchangée pour compatibilité)
  SERVICES_LIST: [
    {
      id: '1xbet',
      name: '1xBet',
      bookmaker: '1xBet',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/1xBetIco.svg',
      bannerImage: '/images/services/1xBetIco.svg',
      idFindingMockup: '/images/screenshots/1xbet-account-id-getting.webp',
      color: '#002E5E',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges',
      event: EVENTS.SERVICES.OPTIONS.SELECT
    },
    {
      id: 'betwinner',
      name: 'Betwinner',
      bookmaker: 'Betwinner',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/betwinner-full.png',
      bannerImage: '/images/services/betwinner-full.png',
      idFindingMockup: '/images/screenshots/betwinner-account-id-getting.webp',
      color: '#1F7E5C',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges',
      event: EVENTS.SERVICES.OPTIONS.SELECT
    },
    {
      id: '1win',
      name: '1Win',
      bookmaker: '1Win',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/1winIcon.svg',
      bannerImage: '/images/services/1winIcon.svg',
      idFindingMockup: '/images/screenshots/1win-account-id-getting.webp',
      color: '#080E1E',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges',
      event: EVENTS.SERVICES.OPTIONS.SELECT
    },
    {
      id: 'eightStarz',
      name: '888Starz',
      bookmaker: '888Starz',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/eightStarz.png',
      bannerImage: '/images/services/eightStarz.png',
      idFindingMockup: '/images/screenshots/eightStarz-account-id-getting.webp',
      color: '#771512',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges',
      event: EVENTS.SERVICES.OPTIONS.SELECT
    },
    {
      id: 'melbet',
      name: 'Melbet',
      bookmaker: 'Melbet',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/melbetIcon.svg',
      bannerImage: '/images/services/melbetIcon.svg',
      idFindingMockup: '/images/screenshots/melbet-account-id-getting.png',
      color: '#272727',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges',
      event: EVENTS.SERVICES.OPTIONS.SELECT
    },
    // {
    //   id: 'giftCard',
    //   name: 'Cartes Cadeaux',
    //   description: 'Achat & Vente',
    //   descriptionLarge: 'Achat & Vente',
    //   logo: '/images/services/gift-card.svg',
    //   bannerImage: '/images/services/gift-card.svg',
    //   color: '#e76f51',
    //   isAvailable: true,
    //   isDarkBg: false,
    //   group: 'others',
    //   event: EVENTS.SERVICES.OPTIONS.SELECT
    // },
    {
      id: 'usdt',
      name: 'USDT',
      description: 'Achat & Vente',
      descriptionLarge: 'Achat & Vente',
      logo: '/images/services/usdtIcon.svg',
      bannerImage: '/images/services/usdtIcon.svg',
      color: '#55AD94',
      isAvailable: false,
      notAvailableMessage: 'Les opérations d\'achat et vente sont temporairement indisponibles',
      isDarkBg: false,
      group: 'trade',
      event: EVENTS.SERVICES.OPTIONS.SELECT
    },
    // {
    //   id: 'subscription',
    //   name: 'Abonnements',
    //   description: 'Vos abonnements facile',
    //   descriptionLarge: 'Vos abonnements facile',
    //   logo: '/images/services/sabonner.png',
    //   bannerImage: '/images/services/sabonner.png',
    //   color: '#354E92',
    //   isAvailable: true,
    //   isDarkBg: true,
    //   notAvailableMessage:
    //     'La commande de repas est bientot disponible chez vous',
    //   group: 'others',
    //   event: EVENTS.SERVICES.OPTIONS.SELECT
    // },
    ...[
      {
        name: 'Netflix',
        icon: '/images/services/netflix.svg',
        url: 'https://store.kingrecharges.com/produit/?id=netflix12345'
      },
      {
        name: 'PrimeVideo',
        icon: '/images/services/prime-video.svg',
        url: 'https://store.kingrecharges.com/produit/?id=primevideo67890'
      },
      {
        name: 'Disney',
        icon: '/images/services/disney-plus.svg',
        url: 'https://store.kingrecharges.com/produit/?id=disneyplus54321'
      },
      {
        name: 'Crunchyrol',
        icon: '/images/services/crunchyroll.svg',
        url: 'https://store.kingrecharges.com/produit/?id=crunchyroll98765'
      },
      {
        name: 'Spotify',
        icon: '/images/services/spotify.svg',
        url: 'https://store.kingrecharges.com/produit/?id=spotify12345'
      },
      {
        name: 'NordVPN',
        icon: '/images/services/nordvpn.svg',
        url: 'https://store.kingrecharges.com/produit/?id=nordvpn67890'
      },
      {
        name: 'PrivateVPN',
        icon: '/images/services/privatevpn.png',
        url: 'https://store.kingrecharges.com/produit/?id=privatevpn54321'
      },
      {
        name: 'CyberGhost',
        icon: '/images/services/cyberghost.webp',
        url: 'https://store.kingrecharges.com/produit/?id=cyberghost98765'
      },
      {
        name: 'Adn',
        icon: '/images/services/adn.svg',
        url: 'https://store.kingrecharges.com/produit/?id=adn12345'
      }
    ].map((el) => {
      return {
        id: el.name,
        name: el.name,
        description: `Abonnement ${el.name}`,
        descriptionLarge: `Abonnement ${el.name}`,
        logo: el.icon,
        color: '#55AD94',
        group: 'others',
        event: EVENTS.SERVICES.OPTIONS.SELECT,
        options: [
          {
            serviceId: el.name,
            id: 'subscription',
            title: `Abonnement ${el.name}`,
            description: `Lancer votres abonnement ${el.name}`,
            smallDescription: `Lancer votres abonnement ${el.name}`,
            url: el.url || 'https://store.kingrecharges.com/'
          }
        ]
      };
    })
  ],
  SERVICES_OPTIONS: {
    '1xbet': [
      {
        serviceId: '1xbet',
        id: 'fund',
        title: 'Recharge',
        description: 'Déposez rapidement sur votre compte 1xBet.',
        smallDescription: 'Rechargez votre compte'
      },
      {
        serviceId: '1xbet',
        id: 'withdraw',
        title: 'Retrait',
        description: 'Retirez vos fonds 1xBet simplement.',
        smallDescription: 'Lancez votre retrait'
      }
    ],

    '1win': [
      {
        serviceId: '1win',
        id: 'fund',
        title: 'Recharge',
        description: 'Déposez rapidement sur votre compte 1Win.',
        smallDescription: 'Rechargez votre compte'
      },
      {
        serviceId: '1win',
        id: 'withdraw',
        title: 'Retrait',
        description: 'Retirez vos fonds 1Win simplement.',
        smallDescription: 'Lancez votre retrait'
      }
    ],

    betwinner: [
      {
        serviceId: 'betwinner',
        id: 'fund',
        title: 'Recharge',
        description: 'Déposez rapidement sur votre compte BetWinner.',
        smallDescription: 'Rechargez votre compte'
      },
      {
        serviceId: 'betwinner',
        id: 'withdraw',
        title: 'Retrait',
        description: 'Retirez vos fonds BetWinner simplement.',
        smallDescription: 'Lancez votre retrait'
      }
    ],

    melbet: [
      {
        serviceId: 'melbet',
        id: 'fund',
        title: 'Recharge',
        description: 'Déposez rapidement sur votre compte MelBet.',
        smallDescription: 'Rechargez votre compte'
      },
      {
        serviceId: 'melbet',
        id: 'withdraw',
        title: 'Retrait',
        description: 'Retirez vos fonds MelBet simplement.',
        smallDescription: 'Lancez votre retrait'
      }
    ],

    eightStarz: [
      {
        serviceId: 'eightStarz',
        id: 'fund',
        title: 'Recharge',
        description: 'Déposez rapidement sur votre compte 8Starz.',
        smallDescription: 'Rechargez votre compte'
      },
      {
        serviceId: 'eightStarz',
        id: 'withdraw',
        title: 'Retrait',
        description: 'Retirez vos fonds 8Starz simplement.',
        smallDescription: 'Lancez votre retrait'
      }
    ],

    pm: [
      {
        serviceId: 'pm',
        id: 'buy',
        title: 'Achat PM',
        description: 'Achetez du Perfect Money rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'pm',
        id: 'sell',
        title: 'Vente PM',
        description: 'Vendez votre Perfect Money facilement.',
        smallDescription: 'Vente rapide'
      }
    ],

    usdt: [
      {
        serviceId: 'usdt',
        id: 'buy',
        title: 'Achat USDT',
        description: 'Achetez du USDT rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'usdt',
        id: 'sell',
        title: 'Vente USDT',
        description: 'Vendez votre USDT facilement.',
        smallDescription: 'Vente rapide'
      }
    ],

    wallet: [
      {
        serviceId: 'wallet',
        id: 'fund',
        title: 'Recharge Wallet',
        description: 'Déposez rapidement sur votre portefeuille.',
        smallDescription: 'Recharge rapide'
      },
      {
        serviceId: 'wallet',
        id: 'withdraw',
        title: 'Retrait Wallet',
        description: 'Retirez vos fonds simplement.',
        smallDescription: 'Retrait rapide'
      }
    ],

    giftCard: [
      {
        serviceId: 'giftCard',
        id: 'buy',
        title: 'Achat Gift Card',
        description: 'Achetez des Gift Cards rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'giftCard',
        id: 'sell',
        title: 'Vente Gift Card',
        description: 'Vendez vos Gift Cards facilement.',
        smallDescription: 'Vente rapide'
      }
    ]
  },
  PAYMENT_METHODS: [
    {
      id: 'mobileMoney',
      name: 'Mobile Money'
    }
  ],
  RECIPIENT_METHODS: [
    {
      id: 'mobileMoney',
      name: 'Mobile Money'
    }
  ],
  BOOKMAKER_WITHDRAWAL_ADDRESS_KEYS: {
    '1xbet': 'xbetWithdrawAddress',
    '1win': 'oneWinWithdrawAddress',
    betwinner: 'betwinnerWithdrawAddress',
    melbet: 'melbetWithdrawAddress',
    eightStarz: 'eightStarzWithdrawAddress'
  },
  BOOKMAKER_LIMIT_FIELD_MAPPING: {
    '1xbet': 'Xbet',
    '1win': 'OneWin',
    betwinner: 'Betwinner',
    melbet: 'Melbet',
    eightStarz: 'EightStarz',
    pm: 'Pm',
    usdt: 'Usdt'
  },
  // Services filtrés: uniquement les abonnements (group: 'others')
  SUBSCRIPTION_SERVICES_ONLY: []
    .concat([
      {
        id: '1xbet',
        name: '1xBet',
        bookmaker: '1xBet',
        description: 'Recharges & Retraits',
        descriptionLarge: 'Recharges & Retraits',
        logo: '/images/services/1xBetIco.svg',
        bannerImage: '/images/services/1xBetIco.svg',
        idFindingMockup: '/images/screenshots/1xbet-account-id-getting.webp',
        color: '#002E5E',
        isAvailable: true,
        isDarkBg: true,
        group: 'recharges',
        event: EVENTS.SERVICES.OPTIONS.SELECT
      },
      {
        id: 'betwinner',
        name: 'Betwinner',
        bookmaker: 'Betwinner',
        description: 'Recharges & Retraits',
        descriptionLarge: 'Recharges & Retraits',
        logo: '/images/services/betwinner-full.png',
        bannerImage: '/images/services/betwinner-full.png',
        idFindingMockup:
          '/images/screenshots/betwinner-account-id-getting.webp',
        color: '#1F7E5C',
        isAvailable: true,
        isDarkBg: true,
        group: 'recharges',
        event: EVENTS.SERVICES.OPTIONS.SELECT
      },
      {
        id: '1win',
        name: '1Win',
        bookmaker: '1Win',
        description: 'Recharges & Retraits',
        descriptionLarge: 'Recharges & Retraits',
        logo: '/images/services/1winIcon.svg',
        bannerImage: '/images/services/1winIcon.svg',
        idFindingMockup: '/images/screenshots/1win-account-id-getting.webp',
        color: '#080E1E',
        isAvailable: true,
        isDarkBg: true,
        group: 'recharges',
        event: EVENTS.SERVICES.OPTIONS.SELECT
      },
      {
        id: 'eightStarz',
        name: '888Starz',
        bookmaker: '888Starz',
        description: 'Recharges & Retraits',
        descriptionLarge: 'Recharges & Retraits',
        logo: '/images/services/eightStarz.png',
        bannerImage: '/images/services/eightStarz.png',
        idFindingMockup:
          '/images/screenshots/eightStarz-account-id-getting.webp',
        color: '#771512',
        isAvailable: true,
        isDarkBg: true,
        group: 'recharges',
        event: EVENTS.SERVICES.OPTIONS.SELECT
      },
      {
        id: 'melbet',
        name: 'Melbet',
        bookmaker: 'Melbet',
        description: 'Recharges & Retraits',
        descriptionLarge: 'Recharges & Retraits',
        logo: '/images/services/melbetIcon.svg',
        bannerImage: '/images/services/melbetIcon.svg',
        idFindingMockup: '/images/screenshots/melbet-account-id-getting.png',
        color: '#272727',
        isAvailable: true,
        isDarkBg: true,
        group: 'recharges',
        event: EVENTS.SERVICES.OPTIONS.SELECT
      },
      {
        id: 'usdt',
        name: 'USDT',
        description: 'Achat & Vente',
        descriptionLarge: 'Achat & Vente',
        logo: '/images/services/usdtIcon.svg',
        bannerImage: '/images/services/usdtIcon.svg',
        color: '#55AD94',
        isAvailable: false,
        notAvailableMessage: 'Les opérations d\'achat et vente sont temporairement indisponibles',
        isDarkBg: false,
        group: 'trade',
        event: EVENTS.SERVICES.OPTIONS.SELECT
      }
    ])
    .filter((service) => service.group === 'others')
    .concat(
      [
        {
          name: 'Netflix',
          icon: '/images/services/netflix.svg',
          url: 'https://store.kingrecharges.com/produit/?id=netflix12345'
        },
        {
          name: 'PrimeVideo',
          icon: '/images/services/prime-video.svg',
          url: 'https://store.kingrecharges.com/produit/?id=primevideo67890'
        },
        {
          name: 'Disney',
          icon: '/images/services/disney-plus.svg',
          url: 'https://store.kingrecharges.com/produit/?id=disneyplus54321'
        },
        {
          name: 'Crunchyrol',
          icon: '/images/services/crunchyroll.svg',
          url: 'https://store.kingrecharges.com/produit/?id=crunchyroll98765'
        },
        {
          name: 'Spotify',
          icon: '/images/services/spotify.svg',
          url: 'https://store.kingrecharges.com/produit/?id=spotify12345'
        },
        {
          name: 'Adn',
          icon: '/images/services/adn.svg',
          url: 'https://store.kingrecharges.com/produit/?id=adn12345'
        },
        {
          name: 'NordVPN',
          icon: '/images/services/nordvpn.svg',
          url: 'https://store.kingrecharges.com/produit/?id=nordvpn67890'
        },
        {
          name: 'PrivateVPN',
          icon: '/images/services/privatevpn.png',
          url: 'https://store.kingrecharges.com/produit/?id=privatevpn54321'
        },
        {
          name: 'CyberGhost',
          icon: '/images/services/cyberghost.webp',
          url: 'https://store.kingrecharges.com/produit/?id=cyberghost98765'
        }
      ].map((el) => {
        return {
          id: el.name,
          name: el.name,
          description: `Abonnement ${el.name}`,
          descriptionLarge: `Abonnement ${el.name}`,
          logo: el.icon,
          color: '#55AD94',
          group: 'others',
          event: EVENTS.SERVICES.OPTIONS.SELECT,
          options: [
            {
              serviceId: el.name,
              id: 'subscription',
              title: `Abonnement ${el.name}`,
              description: `Lancer votres abonnement ${el.name}`,
              smallDescription: `Lancer votres abonnement ${el.name}`,
              url: el.url || 'https://store.kingrecharges.com/'
            }
          ]
        };
      })
    ),
  USDT_ADDRESS_TYPES: [
    {
      id: 'trc20',
      addressName: 'TRC20',
      addressId: 'usdtTrc20Address',
      name: 'USDT TRC20'
    },
    {
      id: 'erc20',
      addressName: 'ERC20',
      addressId: 'usdtErc20Address',
      name: 'USDT ERC20'
    },
    {
      id: 'bep20',
      addressName: 'BEP20',
      addressId: 'usdtBep20Address',
      name: 'USDT BEP20'
    },
    {
      id: 'binance',
      addressName: 'ID Binance',
      addressId: 'binanceAccountId',
      name: 'Compte Binance'
    }
  ]
};
